export default {
  teacherFeedback: {
    title: 'Teacher Feedback:'
  }
};